import { render } from "./GruposListaEsperaModal.vue?vue&type=template&id=3036ecda&scoped=true"
import script from "./GruposListaEsperaModal.vue?vue&type=script&lang=js"
export * from "./GruposListaEsperaModal.vue?vue&type=script&lang=js"

import "./GruposListaEsperaModal.vue?vue&type=style&index=0&id=3036ecda&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3036ecda"]])

export default __exports__